// 本番環境(東京リージョン)
const awsInfo = {
  // Cognito. (NC)
  userPoolId: 'ap-northeast-1_n3gJ737xK',
  appClientId: '3gkjs9rph1fnhchi737jr2ok4j',
  // API Gateway.
  webapiUrl: 'https://api120.nilimo.nsl-bm.healthcare.nikon.com',
}

export { awsInfo }
